/**
 * useCreateWorkshop — mutation hook for the Create Workshop drawer (BON-203).
 * POSTs a draft workshop and, on success, invalidates the dashboard list
 * queries so the new draft appears on the calendar. Returns the standard
 * react-query mutation object; the drawer reads `mutateAsync` / `isPending`.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createWorkshop,
  type WorkshopCreateInput,
  type WorkshopDetail,
} from '../../../../api/workshops';

export function useCreateWorkshop() {
  const qc = useQueryClient();
  return useMutation<WorkshopDetail, Error, WorkshopCreateInput>({
    mutationFn: (input) => createWorkshop(input),
    onSuccess: () => {
      // The new draft belongs on every dashboard calendar that lists workshops.
      qc.invalidateQueries({ queryKey: ['dashboards.admin'] });
      qc.invalidateQueries({ queryKey: ['dashboards.regional'] });
      qc.invalidateQueries({ queryKey: ['dashboards.teacher'] });
      qc.invalidateQueries({ queryKey: ['workshops'] });
    },
  });
}
